module.exports = __webpack_public_path__ + "img/white-logo-vert.3e9918d0.png";